<template>
    <div :class="classes">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: ["open"],
        name: "AccordionContent",
        computed: {
            classes(){
                return `accordion__content2${ this.open ? ' accordion__content2--active' : ''}`;
            }
        }
    }
</script>